import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { PATCH_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { GlossaryResponse, UpdateGlossaryRequest } from '@utils/types/glossary';

export const useUpdateGlossary = (glossaryId: number) => {
  const queryClient = useQueryClient();

  const updateGlossary = async (payload: UpdateGlossaryRequest) => {
    const response = await Axios.patch<GlossaryResponse>(
      PATCH_URL(glossaryId.toString()).updateGlossary,
      payload
    );
    return response.data;
  };

  return useMutation<
    GlossaryResponse,
    AxiosError<BaseError>,
    UpdateGlossaryRequest
  >(updateGlossary, {
    onSuccess: () => {
      queryClient.invalidateQueries('glossaries');
      queryClient.invalidateQueries(['glossary', glossaryId]);
    },
    useErrorBoundary: false
  });
};
